import React from 'react';
import { useTranslation } from 'react-i18next';

import TablesToggle from '../../../../shared-components/tables-toggle/TablesToggle';

import RequestApproved from './RequestApproved';
import RequestPending from './RequestPending';
import RequestRejected from './RequestRejected';

/**
 * Request Pages
 * @returns
 */
function RequestList() {
  const { t, i18n } = useTranslation('penaltyManagement');
  return (
    <div className="request-list" dir={i18n.dir()}>
      <TablesToggle
        tabs={[
          { label: t('approved'), content: <RequestApproved /> },
          { label: t('pending'), content: <RequestPending /> },
          { label: t('rejected'), content: <RequestRejected /> },
        ]}
      />
    </div>
  );
}

export default RequestList;
